<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #end>
        <el-form-item class="endBtn">
          <!-- 导出按钮 -->
          <el-button type="primary" icon="el-icon-download" @click="Export(`月度统计表`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <!-- <template #month="params">
        {{ params.params.month ? Number(params.params.month.split('-')[1]) + '月' : "-" }}
      </template> -->
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'monther',
      breadcrumb: [
        { name: "财务管理", path: `/finance/monthlyStatistical` },
        { name: "月度统计表", path: `/finance/monthlyStatistical` },
      ],
      formInline: { year: undefined },
      formCtrl: [
        {
          label: "年份：",
          placeholder: "请选择年份",
          keyName: "year",
          type: 'year',
        },
      ],
      cols: [
        { prop: "month", label: "月份" },
        { prop: "allprofit", label: "公司利润", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "allfreight", label: "公司运费", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "allinfreight", label: "司机运费", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "drivermoney", label: "司机工资", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "escortmoney", label: "押运员工资", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "fleetmoney", label: "车队长工资", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "allrepair", label: "维修费用", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "allfixed", label: "固定费用", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "gomoney", label: "出车费用", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "contractmpen", label: "合同补差", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "allinprofit", label: "车队利润", align: 'right', className: 'pr30', minwidth: 120 },
      ],
      getTotalProperty: ['drivermoney', 'escortmoney', 'allinfreight', "fleetmoney", "allfreight", "allrepair", "allfixed", "gomoney", "allprofit", 'allinprofit', 'contractmpen'],
      baseParams: ['year'],
    };
  },
  methods: {},
  mounted() {
    // // console.log({ ...this.formInline })
    this.formInline.year = this.DATE_OBJ.y
    // console.log({ ...this.formInline })
    this.getList()
  },
};
</script>
